export const GET_SPACES = `spaces/`;
export const CREATE_SPACE = `spaces/`;
export const DELETE_SPACE = (id) => `spaces/delete/${id}`;
export const UPDATE_SPACE = (id) => `spaces/update/${id}`;
export const GET_TRACKS_FOR_SPACE = (id) => `spaces/${id}/tracks`;
export const PUBLISH_SPACE = (id) => `spaces/${id}/publish`;
export const UNPUBLISH_SPACE = (id) => `spaces/${id}/unPublish`;
